import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HistoryDialogType } from '@shared/models/history-events.model';
import { ZDialogComponent } from '../z-dialog/z-dialog.component';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { EmptyDataComponent } from '../empty-data/empty-data.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-history-dialog',
    templateUrl: './history-dialog.component.html',
    styleUrl: './history-dialog.component.scss',
    imports: [ZDialogComponent, NgIf, NgFor, EmptyDataComponent, DatePipe, TranslatePipe]
})
export class HistoryDialog {
  constructor(
    private dialogRef: MatDialogRef<HistoryDialog>,
    @Inject(MAT_DIALOG_DATA) public history: HistoryDialogType[],
  ) { }

  ngOnInit(): void {
    if (!this.history) {
      this.history = [
        {
          data: new Date('2025-07-03T10:14:25'),
          usuario: 'QA - teste',
          titulo: 'Conciliação Aberta.',
          mensagem: 'Novo Item a ser Conciliado no valor de R$ 300.000,00',
          arquivoNome: '03072025_1014-Extrato_Santander (1) (1).xlsx',
          arquivoLink: '/caminho/para/arquivo1.xlsx',
        },
        {
          data: new Date('2025-07-03T10:14:00'),
          usuario: 'QA - teste',
          titulo: 'Comprovante do valor total da Conciliação foi Enviado.',
          mensagem: 'teste',
        },
      ];
    }
  }
}
